import {initBookmarkedSessions, initSessions, toggleBookmark} from "actions/sessionAction";
import {connect} from 'react-redux';
import {setCurrentPath} from "reducers/NavmenuReducer";
import LearningHub from "views/LearningHub";

const mapStateToProps = ({session: {allSessions, mySessions, bookmarkedSessions}}) => ({
  allSessions,
  mySessions,
  bookmarkedSessions,
});

export default connect(mapStateToProps, {
  initSessions,
  initBookmarkedSessions,
  toggleBookmark,
  setCurrentPath,
})(LearningHub);
